export const isExpired = ({ offer }) => offer?.expired
